
import React from 'react';

import SimpleDialog from "app/common/SimpleDialog";
import StaffNameDialog from "app/common/StaffNameDialog";
import { IBaseProps as IProps } from "./types"

const NS = 'SimpleDialogMain';

export default function SimpleDialogMain(props: IProps) {
  if (props.staffNameRequired) {
    return <StaffNameDialog {...props} />;
  }

  return <SimpleDialog {...props}/>;
}

